import {
  CardContainer,
  Container,
  LeftSection,
  SectionHeadingSkeleton,
  StickyPageHeaderSkeletonWithButtons,
} from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          {/* <HeaderLoading readOnly /> */}

          <CardContainer>
            <SectionHeadingSkeleton />
            <PhoneNumberLoading />
          </CardContainer>
        </LeftSection>
      </Container>
    </>
  );
}
